export default function responseHandler(res)
{
    return res;
}